import { createAction, props } from '@ngrx/store';

export const loadEditionsMetaData = createAction(
  '[Editions] Load Editions Metadata',
  props<{ id: string }>(),
);

export const loadEditionsMetaDataComplete = createAction(
  '[Editions] Load Editions Metadata complete',
  props<{ data: any }>(),
);

export const loadEditionsMetaDataFailure = createAction(
  '[Editions] Load Editions Metadata failure',
  props<any>(),
);

